<template>
  <div class="apps">
    <EntityList
      v-bind:endpoint="'api/versions'"
      v-bind:filters="'?order[name]=desc'"
      v-bind:entity="versionEntity"
      v-bind:editAllowedFields="['name']"
      v-bind:notDisplayedFields="['id']"
      v-bind:addLinkToDetails="true"
      v-bind:detailsRouterName="'versiondetails'"
      v-bind:defaultValues="{}"
      v-bind:title="'Version'"/>
  </div>
</template>

<script>
import EntityList from './EntityList/EntityList.vue';
import VersionEntity from '../store/entity/Version';

export default {
  name: 'Versions',
  components: { EntityList },
  data() {
    return {
      versionEntity: VersionEntity,
    };
  },
};
</script>

<style scoped>

</style>
